import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(
    JSON.parse(localStorage.getItem('isLoggedIn')) || false
  );
  const [financePermissions,setFinancePermissions]=useState({finance:false,rents:false});

  const [financePermissionsStatus,setFinancePermissionsStatus]=useState('loading');

  useEffect(()=>{
    let active=true;
    let controller;
    const refresh=async()=>{
      if(controller)controller.abort();
      controller=new AbortController();
      const current=controller;
      setFinancePermissions({finance:false,rents:false});
      if(!isLoggedIn){setFinancePermissionsStatus('idle');return;}
      setFinancePermissionsStatus('loading');
      try{
        const response=await fetch(`${process.env.REACT_APP_API_URL || ''}/api/finance/permissions/`,{credentials:'include',cache:'no-store',signal:current.signal});
        if(!response.ok){if(active&&!current.signal.aborted)setFinancePermissionsStatus('error');return;}
        const body=await response.json();
        if(active&&!current.signal.aborted){setFinancePermissions({finance:body.finance===true,rents:body.rents===true});setFinancePermissionsStatus('ready');}
      }catch(e){if(active&&!current.signal.aborted)setFinancePermissionsStatus('error');/* Fail closed. */}
    };
    refresh();
    return ()=>{active=false;if(controller)controller.abort();};
  },[isLoggedIn]);

  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn);
  }, [isLoggedIn]);

  const logout = () => {
    setFinancePermissionsStatus('idle');
    setFinancePermissions({finance:false,rents:false});
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
    // slash-app の chat 認証で使っている JWT もクリア
    localStorage.removeItem('slashapp_access');
    localStorage.removeItem('slashapp_refresh');
    localStorage.removeItem('slashapp_sub_id');
  };

  const value = {
    isLoggedIn,
    setIsLoggedIn,
    logout,
    financePermissions,
    financePermissionsStatus,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
